// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2786":"adabba20","4906":"a80ef58f","8954":"a8062578"}[chunkId] + ".chunk.css";
};